<!--
  @Description: 
  @Author: wang.y 
  @Date: 2022-05-06 
-->
<template>
  <div class="theme">
    <Spin fix class="index-loading" v-if="loading">
      <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin>
    <div class="theme-list">
      <div class="theme-li" v-for="item in list" :key="item.id">
        <div class="img" @click="goList(item.id)">
          <img :src="item.logoPath | logo_show" />
        </div>
        <p class="name" @click="goList(item.id)">{{item.name}}</p>
        <p class="des">{{item.description}}</p>
      </div>
    </div>
    <div class="more_div" v-if="is_more">
      <Button @click="more()" :loading="more_loading" :class="more_loading ? 'more_loading' : ''">{{more_loading ? '加载中' : '加载更多'}}</Button>
    </div>
  </div>
</template>
<script>
import { serieslist } from '@/service'
export default {
  components: {},
  created() {
    this.params.type = this.$route.query.type || 0
    this.getList()
  },
  mounted() {},
  data() {
    return {
      list: [],
      params: {
        page: 1,
        size: 9,
        type: 0,
      },
      loading: true,
      more_loading: false,
      is_more: true,
    }
  },
  computed: {},
  methods: {
    async getList() {
      this.more_loading = true
      let res = await serieslist(this.params, (error) => {
        this.$message.error('请求错误！')
      })
      this.more_loading = false
      this.loading = false
      if (res.code == 0) {
        this.list = [...this.list, ...res.data]
        this.is_more = res.data.length == this.params.size
      } else {
        this.$message.error(res.msg)
      }
    },
    more() {
      ++this.params.page
      this.getList()
    },
    goList(id) {
      let url = this.$store.state.index2_path + '/seriesD/' + id
      window.open(url)
    },
  },
}
</script>
<style lang='stylus' scoped>
.theme
  background #fff
  min-height calc(100vh - 64px)
  position relative
  >>>.ivu-spin
    color #FF8824
  &-list
    margin 0 auto
    width 1200px
    display flex
    flex-wrap wrap
    padding-bottom 30px
  &-li
    width 370px
    margin-right 45px
    padding-top 30px
    &:nth-of-type(3n)
      margin-right 0
    .img
      width 370px
      height 220px
      background-color #f0f0f0
      display flex
      align-items center
      justify-content center
      font-size 0
      overflow hidden
      img
        height 100%
        transition all 0.3s
        cursor pointer
        &:hover
          transform scale(1.05)
    .name
      color #333
      font-size 18px
      font-weight 800
      line-height 48px
      overflow hidden
      height 48px
      white-space nowrap
      text-overflow ellipsis
      border-bottom 1px solid #e8e8e8
      cursor pointer
      transition all 0.3s
      &:hover
        color #ff8824
    .des
      font-size 14px
      line-height 22px
      height 44px
      display -webkit-box
      overflow hidden
      max-height 44px
      margin-top 10px
      text-overflow ellipsis
      word-break break-all
      color #999
      -webkit-box-orient vertical
      -webkit-line-clamp 2
  .more_div
    text-align center
    padding-bottom 30px
    padding-right 14px
    button
      color #ff8824
      border 1px solid #ff8824
      width 126px
      height 38px
      background-color #fff
      cursor pointer
      border-radius 20px
      &:focus
        box-shadow none
    .more_loading
      border 0
</style>